var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "i",
        _vm._b(
          {
            staticClass: "wy-permission-icon",
            attrs: { loading: _vm.loading },
            on: { click: _vm.handleClick },
          },
          "i",
          _vm.$attrs,
          false
        ),
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }